import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { TButtonStyles, buttonStylesOptions } from '../../common/buttons/button-style/button-style.component';
import { iconsOptions } from '../../styles/cms.config';

export namespace NCmsServiceMessages {
    export interface IComponentData extends NICmsContentComponent.IData {
        services?: IServiceMessage[];
    }

    /**
     * Link interface
     */
    export interface IServiceMessage {
        icon: string;
        title: string;
        description?: string;
        link_button: boolean;
        button_style?: TButtonStyles;
        cta_copy?: string;
        cta_link?: string;
    }
}

@ICmsComponent<CmsServiceMessagesComponent>({
    id: 'service-messages',
    name: 'Service Messages',
    tags: ['PDP', 'Links'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'services',
            title: 'Services',
            itemNameField: 'title',
            minSize: 3,
            maxSize: 4,
            fields: [
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'icon',
                    title: 'Icon',
                    options: iconsOptions,
                    default: 'icon-wishlist',
                    previewMode: 'icon',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Service Message',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.textarea,
                    key: 'description',
                    title: 'Description',
                    default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ultricies enim non lectus vulputate',
                    required: true
                },
                {
                    key: 'link_button',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Button type',
                    description: 'If enabled, the button will be link type',
                    default: true,
                    required: true
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'button_style',
                    title: 'Button Style',
                    options: buttonStylesOptions,
                    default: 'button-1',
                    canShow: (data: NCmsServiceMessages.IServiceMessage) => !data.link_button
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'cta_copy',
                    title: 'Button Label',
                    default: 'Button label'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'cta_link',
                    title: 'Link',
                    default: '/'
                }
            ],
            defaultSize: 3
        },
        NICmsContentComponent.backgroundField
    ]
})
@Component({
    selector: 'cms-service-messages',
    templateUrl: './cms-service-messages.html',
    styleUrls: ['./cms-service-messages.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsServiceMessagesComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsServiceMessages.IComponentData;

    get pcSlides() {
        return [1, 3, 4, 4][this.client.sizeId];
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }
}
